var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseButton = function SvgCloseButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-69.1%",
    y: "-54.4%",
    width: "238.2%",
    height: "238.2%",
    filterUnits: "objectBoundingBox",
    id: "CloseButton_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.285210883 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "CloseButton_svg__b",
    cx: 17,
    cy: 17,
    r: 17
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    filter: "url(#CloseButton_svg__a)",
    xlinkHref: "#CloseButton_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F99137",
    xlinkHref: "#CloseButton_svg__b"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.725 23.955a.68.68 0 0 1-.48-1.16l12.55-12.55a.68.68 0 1 1 .96.96l-12.55 12.55c-.127.128-.3.2-.48.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.275 23.955a.677.677 0 0 1-.48-.2l-12.55-12.55a.68.68 0 0 1 .96-.96l12.55 12.55a.68.68 0 0 1-.48 1.16Z"
  })))));
};
export default SvgCloseButton;